export interface Coordinates {
  lat: number;
  lng: number;
}

export const getGeolocation = (): Promise<{
  latitude: number;
  longitude: number;
}> => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        resolve({ latitude, longitude });
      },
      (error) => reject(error),
    );
  });
};

export const geocodeLocation = async (lat: number, lng: number) => {
  const geocoder = new google.maps.Geocoder();
  const { results } = await geocoder.geocode({
    location: { lat, lng },
  });
  return results;
};

export const geocodeCurrentLocation = async (): Promise<google.maps.GeocoderResult[]> => {
  const { latitude, longitude } = await getGeolocation();
  return geocodeLocation(latitude, longitude);
};

// Forked the above version into a hexagon geolocation to supply to EV api
// using the Harvesine formula
export const getGeoLocationRadius = (lat: number, lng: number, radius: number): number[][][][] => {
  // gets hexagon geolocation to supply to EV api
  // using Haversine formula
  const R = 3963.189; // Earth's radius in miles
  const dLat = radius / R;
  const dLng = radius / (R * Math.cos((Math.PI * lat) / 180));
  const lat1 = lat;
  // const lat2 = lat + dLat * 180 / Math.PI; // not used
  const lat3 = lat + (dLat * 180) / Math.PI / 2;
  const lat4 = lat - (dLat * 180) / Math.PI / 2;
  const lng1 = lng;
  const lng2 = lng + (dLng * 180) / Math.PI;
  const lng3 = lng + (dLng * 180) / Math.PI / 2;
  const lng4 = lng - (dLng * 180) / Math.PI / 2;

  const geoPolygon = [
    [
      [
        [lng2, lat1],
        [lng3, lat3],
        [lng3, lat4],
        [lng1, lat1],
        [lng4, lat4],
        [lng4, lat3],
        [lng2, lat1],
      ],
    ],
  ];
  return geoPolygon;
};
